<template>
    <div>
        <div class="products__tiles">
            <product-tile v-for="product in filteredProducts" :key="product.id" :product="product" @selected="selectProduct" @unselected="unselectProduct"></product-tile>

            <product-tile :show="show" v-for="product in otherProducts" :key="product.id" :product="product"  @selected="selectProduct" @unselected="unselectProduct"></product-tile>
        </div>

        <div class="products-toggler" >
            <a @click="show = !show">
                <span v-if="!show">{{ trans('products.show_more') }}</span>
                <span v-else>{{ trans('products.show_less') }}</span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        products: Array,
        filter: String,
    },

    data() {
        return {
            show: false,
            selectedProducts: [],
        };
    },

    computed: {
        filterType() {
            if (this.filter != 'lkw' && this.filter != 'pkw') {
                return 'car';
            }

            if (this.filter == 'lkw') {
                return 'truck';
            }

            if (this.filter == 'pkw') {
                return 'car';
            }
        },

        filteredProducts() {
            return this.products.filter(product => {
                return product.type == this.filterType;
            });
        },

        otherProducts() {
            return this.products.filter(product => {
                return product.type != this.filterType;
            });
        },
    },

    methods: {
        selectProduct(product) {
            this.selectedProducts.push(product);
            this.$emit('selected');
        },

        unselectProduct(product) {
            let index = this.selectedProducts.indexOf(product);
            this.selectedProducts.splice(index, 1);

            if (!this.selectedProducts.length) {
                this.$emit('none-selected');
            }
        },
    },
}
</script>
